<div id="our-alumnus" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">Distinguished Alumnae</h2>
    <p class="inner-lead mt-3">
      Our alumnae are the torchbearers of the values instilled at Shah Satnam Ji Girls' College. From international
      sports coaching to academic excellence and administrative leadership, they have ascended to the zenith of their
      professional careers.
    </p>

    <div class="alumni-scroll-container mt-4" #scrollContainer (mouseenter)="stopAutoScroll()"
      (mouseleave)="startAutoScroll()">
      <div class="alumni-card" *ngFor="let alum of displayedAlumni">
        <div class="alumni-img-wrapper">
          <img [src]="alum.image" [alt]="alum.name" class="alumni-img">
        </div>
        <div class="alumni-details">
          <h5 class="alumni-name" [title]="alum.name">{{ alum.name }}</h5>
          <p class="alumni-role" [title]="alum.role">{{ alum.role }}</p>
          <p class="alumni-description">{{ alum.description }}</p>
        </div>
      </div>
    </div>

    <div class="mt-section">
      <h4 class="section-subtitle">Professional Achievements (Prominent Alumni List)</h4>

      <div class="pdf-block mt-3">
        <pdf-viewer src="/assets/pdf/alumni/Prominent Alumini List.pdf" [render-text]="true" [original-size]="false"
          style="width: 100%; height: 800px; display: block;">
        </pdf-viewer>
      </div>

      <!-- <div class="mt-4">
        <a href="/assets/pdf/alumni/Prominent Alumini List.pdf" target="_blank" class="pdf-download-btn">
          <i class="fa fa-download me-2"></i> Download Prominent Alumni List (PDF)
        </a>
      </div> -->
    </div>

    <p class="inner-lead mt-5 text-center italic">
      <em>"Success is not just about what you accomplish in your life; it’s about what you inspire others to do."</em>
    </p>

  </div>
</div>